import { hasCapability, type User } from "../base";

export const scopeOfWorkType = {
  read: (user: User) => hasCapability(user, "scopeOfWorkType.read"),
};
